import type { NomeIcona } from './icone'

export type Permesso =
  | 'dichiarazioni_ad1'
  | 'scadenziari'
  | 'registri_letture'
  | 'praticheenergia_green'
  | 'vede_tutti_impianti'
  | 'gestione'

export interface VoceMenu {
  etichetta: string
  rotta: string
  icona?: NomeIcona
  permesso?: Permesso
  modulo?: string
  daAttivare?: boolean
  /** Numero rosso accanto alla voce: le cose da guardare subito. */
  conteggio?: 'scadute' | 'anomalie' | 'dichiarazioni'
}

export interface GruppoMenu {
  /** Vuoto: voci in testa al menu, senza intestazione. */
  titolo: string
  /** Gruppo chiuso finche' non si apre o non si e' su una sua pagina. */
  comprimibile?: boolean
  icona?: NomeIcona
  voci: VoceMenu[]
}

// Organizzato per attivita' (cruscotto approvato il 7/10/2026), non per prodotto.
// L'aiuto sta nella barra in alto (BarraSuperiore).
export const MENU: GruppoMenu[] = [
  {
    titolo: '',
    voci: [
      { etichetta: 'Cruscotto', rotta: '', icona: 'cruscotto' },
      { etichetta: 'Impianti', rotta: 'impianti', icona: 'impianti', permesso: 'dichiarazioni_ad1' },
    ],
  },
  {
    titolo: 'ADEMPIMENTI',
    voci: [
      {
        etichetta: 'Scadenzario',
        rotta: 'scadenzario',
        icona: 'calendario',
        permesso: 'scadenziari',
        modulo: 'scadenze',
        conteggio: 'scadute',
      },
      {
        etichetta: 'Dichiarazioni AD-1',
        rotta: 'dichiarazioni',
        icona: 'documento',
        permesso: 'dichiarazioni_ad1',
        conteggio: 'dichiarazioni',
      },
      {
        etichetta: 'Registri letture',
        rotta: 'scadenza_registri',
        icona: 'registro',
        permesso: 'registri_letture',
        modulo: 'registroLetture',
      },
    ],
  },
  {
    titolo: 'PRODUZIONE',
    voci: [
      {
        etichetta: 'Monitoraggio',
        rotta: 'impianti-green',
        icona: 'grafico',
        permesso: 'praticheenergia_green',
        modulo: 'monitoraggioEdistribuzione',
      },
      {
        etichetta: 'Anomalie',
        rotta: 'alert-green',
        icona: 'avviso',
        permesso: 'praticheenergia_green',
        modulo: 'alertEdistribuzione',
        conteggio: 'anomalie',
      },
      { etichetta: 'Configurazione', rotta: 'green-configurazione', icona: 'regolazioni', permesso: 'praticheenergia_green' },
    ],
  },
  {
    titolo: '',
    voci: [{ etichetta: 'Clienti', rotta: 'aziende', icona: 'clienti', permesso: 'dichiarazioni_ad1' }],
  },
  {
    titolo: 'Impostazioni',
    comprimibile: true,
    icona: 'impostazioni',
    voci: [
      { etichetta: 'Account e permessi', rotta: 'account-e-permessi', permesso: 'gestione' },
      { etichetta: 'Credenziali', rotta: 'credenziali-distributore', permesso: 'gestione' },
      { etichetta: 'Log attività', rotta: 'log-attivita', permesso: 'gestione' },
      { etichetta: 'Log email', rotta: 'log-notifiche', permesso: 'gestione' },
      { etichetta: 'Email automatiche', rotta: 'gestione-notifiche', permesso: 'gestione', modulo: 'mailingAutomatico' },
      { etichetta: 'Token e contratti', rotta: 'token-e-contratti', permesso: 'gestione' },
      { etichetta: 'Servizi', rotta: 'servizi', permesso: 'gestione' },
      {
        etichetta: 'Portali personalizzati',
        rotta: 'portali-personalizzati',
        permesso: 'gestione',
        modulo: 'portaliPersonalizzati',
      },
    ],
  },
]

/** Il modulo non acquistato resta visibile con l'invito all'attivazione: non si nasconde. */
export function menuVisibile(
  permessi: readonly string[],
  serviziAttivi: readonly string[],
): GruppoMenu[] {
  return MENU.map((g) => ({
    ...g,
    voci: g.voci
      .filter((v) => v.permesso === undefined || permessi.includes(v.permesso))
      .map((v) => ({
        ...v,
        daAttivare: v.modulo !== undefined && !serviziAttivi.includes(v.modulo),
      })),
  })).filter((g) => g.voci.length > 0)
}
